import { render, staticRenderFns } from "./EmailSettingPreferences.vue?vue&type=template&id=123aa210&scoped=true&"
import script from "./EmailSettingPreferences.vue?vue&type=script&lang=js&"
export * from "./EmailSettingPreferences.vue?vue&type=script&lang=js&"
import style0 from "./EmailSettingPreferences.vue?vue&type=style&index=0&id=123aa210&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123aa210",
  null
  
)

export default component.exports